import axiosClient from "../../../../api/axiosClient";

export const getCategoryOptions = async () => {
  return axiosClient.get("/api/ipe/enquiries/attributes/category-values");
};

export const getManufacturerOptions = async () => {
  return axiosClient.get("/api/ipe/enquiries/attributes/manufacturer-values");
};

export const getBomList = async () => {
  return axiosClient.get("/api/ipe/boms");
};